export function monitoringReport() {
	let reportTimeout: NodeJS.Timeout | undefined;

	return {
		observe: (reason: string, market: string, shouldReport: () => boolean) => {
			if (reportTimeout) clearTimeout(reportTimeout);
			reportTimeout = setTimeout(() => {
				if (shouldReport()) {
					const request = new Request(
						`https://okjq33j1ti.execute-api.eu-central-1.amazonaws.com/default/NgcMonitoring?reason=${reason}&market=${market}`,
					);
					fetch(request).catch(() => console.warn('monitor call send'));
				}
			}, 10000);
		},
	};
}
